/*
 * @Author: gaobin
 * @Date: 2024-08-21 15:58:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-07-04 11:14:45
 * @Description: 接口集合
 */

// 引入子模块API

import addressMap from './address';
import chartMap from './chart';
import commonMap from './common';
import consultOrderMap from './consult-order';
import freeMap from './free';
import globalMap from './global';
import groupMap from './group';
import groupOrderMap from './group-order';
import helpMap from './help';
import historyMap from './history';
import homeMap from './home';
import landPageMap from './landpage';
import loginMap from './login';
import orderMap from './order';
import paymentMap from './payment';
import prizesMap from './prizes';
import productMap from './product';
import searchMap from './search';
import userMap from './user';

export default {
  ...commonMap,
  ...userMap,
  ...globalMap,
  ...freeMap,
  ...helpMap,
  ...groupOrderMap,
  ...prizesMap,
  ...homeMap,
  // 集成子模块API
  ...paymentMap,
  ...groupMap,
  ...historyMap,
  ...landPageMap,
  ...searchMap,
  ...addressMap,
  ...loginMap,
  ...userMap,
  ...productMap,
  ...orderMap,
  ...globalMap,
  ...commonMap,
  ...freeMap,
  ...chartMap,
  ...consultOrderMap,
};
